const Position = ({ text }) => {
  const base =
    'uppercase text-subheadingCardsMobile md:text-subheadingCardsDesktop text-khaki font-chivoMono'

  return <span className={base}>{text}</span>
}

export default Position
